export default __webpack_public_path__ + "static/peopleperhour-logo-02686a4da733b2b6cf6dcfa8d7ea4080.png";